module.exports = __webpack_public_path__ + "static/img/login01_10.f987369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login01_10.png
// module id = 7Wc4
// module chunks = 0